import { IFinancialCockpitQbrDocument } from '../../api/types'

export const getQbrDocumentDisplayName = (
  document: Pick<IFinancialCockpitQbrDocument, 'Name' | 'FYear' | 'FQuarter'>
): string => document.Name || `QBR FY${document.FYear ?? '—'} Q${document.FQuarter ?? '—'}`
